// removed by extract-text-webpack-plugin
module.exports = {"black":"color__black___--buv c-black","steel":"color__steel___2hzJV c-steel","slate":"color__slate___35wQZ c-slate","silver":"color__silver___1GcWN c-silver","smoke":"color__smoke___2R4Iv c-smoke","darkSmoke":"color__darkSmoke___2rScH c-smoke--d","extraDarkSmoke":"color__extraDarkSmoke___CJ8Ii c-smoke--xd","snow":"color__snow___1FvLh c-snow","darkSnow":"color__darkSnow___11Bxu c-snow--d","extraDarkSnow":"color__extraDarkSnow___k2WQT c-snow--xd","white":"color__white___2Uwip c-white","green":"color__green___10tLr c-green","red":"color__red___1DEtm c-red","blue":"color__blue___sQ5t9 c-blue"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-paragraph/Paragraph/style/color.css
// module id = 224
// module chunks = 0 24